import { OrderStatusType } from '@/services/outbound/outboundWaitingStatus/types'
import { pick } from 'lodash-es'

export const ORDER_STATUS: HashMap<OrderStatusType> = {
  ORDER_COLLECTED: 'ORDER_COLLECTED', // 주문수집
  ORDER_ACCEPTED: 'ORDER_ACCEPTED', // 주문접수
  HOLD: 'HOLD', // 출고보류
  INV_UNALLOCATED: 'INV_UNALLOCATED', // 재고미할당
}

// TODO: [SCOPE B] 센터별 예상 할당 수량 기본값 대체 예정
export const DEFAULT_EXPECTED_ALLOCATION_LIST = [
  {
    warehouseName: '신여주1',
    warehouseCode: 'NWH01',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '신여주2',
    warehouseCode: 'NWH02',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '신여주3',
    warehouseCode: 'NWH03',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '신여주4',
    warehouseCode: 'YEJ04',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '신여주5',
    warehouseCode: 'YEJ05',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '신여주Global',
    warehouseCode: 'NWH09',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '신인천',
    warehouseCode: 'NWH04',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '이천1',
    warehouseCode: 'ICH01',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '진천',
    warehouseCode: 'NWH08',
    orderCount: 0,
    orderPcs: 0,
  },
  {
    warehouseName: '파주1',
    warehouseCode: 'PAJ01',
    orderCount: 0,
    orderPcs: 0,
  },
]

// TODO: [SCOPE B] API 대체 예정
export const ORDER_TYPES = {
  NORMAL: '일반',
  PLUS: 'PLUS',
  INTER: '사내',
  INTER_OVERSEAS: '사내(해외)',
  BOUTIQUE: '명품',
  RETURN: '반품',
  OVERSEAS: '해외',
  EXCHANGE: '교환',
  ETC: '기타',
  UNKNOWN: '미지정',
} as const

export const B2B_ORDER_TYPES = pick(ORDER_TYPES, ['INTER', 'INTER_OVERSEAS'])
